import React, { useState, useEffect } from 'react';
import resetIcon from '../../assets/arrows-refresh.svg';
import './progressbar.css';

export default function ProgressBar({ width, percent, status, firstAid, onClose, resetProgressIcon, resetProgress }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue(percent * width);
  });

  return (
    <div className="progressComp fade-in">
      {firstAid ? (
        <div className="progress__main">
          <svg
            onClick={onClose}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.9959 2.9743C13.1908 3.16919 13.1908 3.48518 12.9959 3.68008L3.68008 12.9959C3.48518 13.1908 3.16919 13.1908 2.9743 12.9959C2.7794 12.801 2.7794 12.485 2.9743 12.2901L12.2901 2.9743C12.485 2.7794 12.801 2.7794 12.9959 2.9743Z"
              fill="#03182F"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.9743 2.9743C3.16919 2.7794 3.48518 2.7794 3.68008 2.9743L12.9959 12.2901C13.1908 12.485 13.1908 12.801 12.9959 12.9959C12.801 13.1908 12.485 13.1908 12.2901 12.9959L2.9743 3.68008C2.7794 3.48518 2.7794 3.16919 2.9743 2.9743Z"
              fill="#03182F"
            />
          </svg>
          <div className="progress__container">
            <div className="progress__fill" style={{ width: `${percent}%` }} />
          </div>
          {resetProgressIcon && (
            <button type="button" onClick={resetProgress} className="reset-button">
              <img src={resetIcon} alt="Reset Progress" />
            </button>
          )}
        </div>
      ) : (
        <>
          <h1 className="percent-number">{status}</h1>
          <div className="progress-div" style={{ width }}>
            {value === 0 && <div style={{ width: `${value}vw` }} className="jump" />}
            {value > 0 && <div style={{ width: `${value}vw` }} className="progress" />}
          </div>
        </>
      )}
    </div>
  );
}
